exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".header a {\n  padding: 10px;\n  font-size: 16px;\n}\n", ""]);

